import styled from 'styled-components';

export const ArticleSC = styled.article`
  width: 1005px;
  max-width: 100%;
  margin: 0 auto 24px;
  background: #fff;
  color: #293157;

  h1 {
    font-size: 59px;
    font-weight: 200;
    line-height: 70px;
    margin-bottom: 58px;
  }

  h2 {
    font-size: 29px;
    font-weight: 400;
    line-height: 40px;
    margin-bottom: 20px;
  }

  p {
    font-weight: 300;
    font-size: 18px;
    line-height: 30px;
  }

  blockquote {
    opacity: 0.4;
    font-weight: 300;
    font-size: 47px;
    line-height: 60px;
    margin: 32px 0;
  }

  .article-main-img {
    display: block;
    margin: 0 auto;
    width: auto;
    max-width: 100%;
  }

  .article-meta {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: rgba(24, 30, 52, 0.4);

    span {
      margin-left: 16px;
      &:first-of-type {
        margin-left: 7px;
      }
    }
  }

  .article-padding {
    padding: 64px;
    max-width: 764px;
  }
`;
